<app-webpage-analytics></app-webpage-analytics>

<div class="flex">
    <div class="ontario-row recordContainer">

        <app-breadcrumbs></app-breadcrumbs>

        <div class="divider">
            <h1> {{ 'assessment.record' | translate | async }}: {{ fileId }} </h1>
        </div>

        <app-copy-to-clipboard [index]="databaseIndex" [fileNumber]="fileId"></app-copy-to-clipboard>

        <ng-template [ngTemplateOutlet]="detailsTable"></ng-template>

        <div class="ontario-accordions__container">
            <div class="ontario-accordion__controls">
                <button class="ontario-accordion__button--expand-all" aria-expanded="false">
                    <span class="ontario-accordion--expand-open-all">{{ 'expand.all' | translate | async }}</span>
                    <span class="ontario-accordion--expand-close-all">{{ 'collapse.all' | translate | async }}</span>
                </button>
            </div>
            <div *ngIf="reports || otherDocuments" class="ontario-accordion" id="accordion-1">
                <button class="ontario-accordion__button" id="accordion-button-id-1" aria-controls="accordion-content-1"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'downloads' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-1" aria-labelledby="accordion-button-id-1" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="downloadsTable"></ng-template>
                </section>
            </div>
            <div *ngIf="fileIdentifiers" class="ontario-accordion" id="accordion-2">
                <button class="ontario-accordion__button" id="accordion-button-id-2" aria-controls="accordion-content-2"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'file.identifiers' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-2" aria-labelledby="accordion-button-id-2" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="fileIdentifiersTable"></ng-template>
                </section>
            </div>
            <div *ngIf="workTypes" class="ontario-accordion" id="accordion-3">
                <button class="ontario-accordion__button" id="accordion-button-id-3" aria-controls="accordion-content-3"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'work.types' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-3" aria-labelledby="accordion-button-id-3" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="workTypesTable"></ng-template>
                </section>
            </div>
            <div *ngIf="commodities" class="ontario-accordion" id="accordion-4">
                <button class="ontario-accordion__button" id="accordion-button-id-4" aria-controls="accordion-content-4"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'commodities' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-4" aria-labelledby="accordion-button-id-4" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="commoditiesTable"></ng-template>
                </section>
            </div>
            <div *ngIf="authors" class="ontario-accordion" id="accordion-5">
                <button class="ontario-accordion__button" id="accordion-button-id-5" aria-controls="accordion-content-5"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'authors' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-5" aria-labelledby="accordion-button-id-5" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="authorsTable"></ng-template>
                </section>
            </div>
            <div *ngIf="location" class="ontario-accordion" id="accordion-6">
                <button class="ontario-accordion__button" id="accordion-button-id-6" aria-controls="accordion-content-6"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'location' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-6" aria-labelledby="accordion-button-id-6" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="locationTable"></ng-template>
                </section>
            </div>
            <div *ngIf="claimHolders" class="ontario-accordion" id="accordion-7">
                <button class="ontario-accordion__button" id="accordion-button-id-7" aria-controls="accordion-content-7"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'claim.holders' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-7" aria-labelledby="accordion-button-id-7" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="claimHoldersTable"></ng-template>
                </section>
            </div>
            <div *ngIf="claims" class="ontario-accordion" id="accordion-content-8">
                <button class="ontario-accordion__button" id="accordion-button-id-8" aria-controls="accordion-content-8"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'claims' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-8" aria-labelledby="accordion-button-id-8" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="claimsTable"></ng-template>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-9">
                <button class="ontario-accordion__button" id="accordion-button-id-9" aria-controls="accordion-content-9"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'report.an.error' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-9" aria-labelledby="accordion-button-id-9" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'assessment.report.an.error.text' | translate | async }}">
                            {{ 'assessment.report.an.error.text' | translate | async }}
                    </div>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-10">
                <button class="ontario-accordion__button" id="accordion-button-id-10" aria-controls="accordion-content-10"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'terms.of.use' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-10" aria-labelledby="accordion-button-id-10" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'terms.of.use.link' | translate | async }}">
                            {{ 'terms.of.use.link' | translate | async }}
                        </p>
                    </div>
                </section>
            </div>
        </div>

        <div class="mt-4 divider contactInformationContainer">
            <div class="flex mb-4 ">
                <h3 class="contactInformationTitle">
                    {{ 'contact.information' | translate | async }}
                </h3>   
                <p class="contactInformationValue">

                    {{ 'record.assessment.contact.text' | translate | async }}

                    <a target="_blank" 
                        href="https://www.infogo.gov.on.ca/infogo/#orgProfile/{{contact_rgp.contact}}/en">
                        {{ contact_rgp.rgp_district }}
                    </a> 
                </p> 
            </div>
        </div>

        <ng-template #detailsTable>
            <div>
                <div>
                    <h2 class="mt-3 mb-3">{{ 'assessment.file.details' | translate | async }}</h2>
                </div>
                <div class="assessmentDetailsContainer">
                    <div class="flex">
                        <div *ngIf="fileId" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'file.id' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ fileId | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ fileId | notApplicablePipe | async |highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="fileType" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'file.type' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ fileType | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ fileType | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="residentGeologistDistrict" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'resident.geologist.district' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ residentGeologistDistrict | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ residentGeologistDistrict | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="propertyNames.length > 0" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'property.name' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ propertyNames | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ propertyNames | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                        </div>
                        <div *ngIf="primaryTownship" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'primary.township.area' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ primaryTownship | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ primaryTownship | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="secondaryTownships.length > 0" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'secondary.township.area' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ secondaryTownships | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ secondaryTownships | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
    
                    <div class="flex">
                        <div *ngIf="nts.length > 0" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'nts' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ nts | commaSeparatedPipe:'nts_num' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ nts | commaSeparatedPipe:'nts_num' | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold ">{{ 'year.work.performed' | translate | async }}:</p>
                            <ng-container *ngIf="yearFrom === yearTo || yearTo === 0; else differentYears">
                                <p class="recordValue" innerHTML="{{ yearFrom }}">
                                    {{ yearFrom }}
                                </p>
                            </ng-container>
                            <ng-template #differentYears>
                                <p class="recordValue" innerHTML="{{ yearFrom }} {{ 'to' | translate | async }} {{ yearTo }}">
                                    {{ yearFrom }} {{ 'to' | translate | async }} {{ yearTo }}
                                </p>
                            </ng-template>
                        </div>
                        <div *ngIf="performedFor.length > 0" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'performed.for' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ performedFor | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ performedFor | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="totalValueOfWorkApproved != '0'" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'total.value.work.approved' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="${{ totalValueOfWorkApproved | number | highlight : this.searchTerms }}">
                                ${{ totalValueOfWorkApproved | number | highlight : this.searchTerms }}
                            </p>                                           
                        </div>
                        <div *ngIf="drill_hole_count != '0';" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'drill.hole.summary' | translate | async }}:</p>
                            <a target="_blank" 
                                class="recordValue"
                                innerHTML="{{ fileId | highlight : this.searchTerms }}"

                                href="{{this.drillHoleSummaryPersistentLink}}">
                                {{ fileId | highlight : this.searchTerms }}
                            </a>                                            
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #downloadsTable>
            <div>
                <div *ngIf="reports">
                    <div>
                        <h3 class="mb-2">
                           {{ 'reports' | translate | async }}
                        </h3>
                    </div>
                    <div class="ontario-table-container">
                        <div class="ontario-table-div mb-0">
                            <table class="flex-child" tabindex="0">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'year' | translate | async }}</th>
                                        <th scope="col">{{ 'title' | translate | async }}</th>
                                        <th scope="col">{{ 'file.size.kb' | translate | async }}</th>
                                        <th scope="col">{{ 'pages' | translate | async }}</th>
                                        <th scope="col">{{ 'comments' | translate | async }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let technical_report of record.technical_reports">
                                        <td scope="row">
                                            <ng-container *ngIf="technical_report.year != 0; else na">
                                                <p> {{ technical_report.year }} </p>                                           
                                            </ng-container>
                                            <ng-template #na>
                                                <p>{{ 'na' | translate | async }}</p>
                                            </ng-template>
                                        </td>
                                        <td scope="row">
                                            <ng-container *ngIf="technical_report.file_name; else noUrl">
                                                <a target="_blank" 
                                                    innerHTML="{{ technical_report.title | highlight : this.searchTerms }}"
                                                    href="{{this.downloadsAZStorage}}/{{technical_report.file_name}}">
                                                    {{ technical_report.title | highlight : this.searchTerms }}
                                                </a>                                            
                                            </ng-container>
                                            <ng-template #noUrl>
                                                <p>
                                                    {{ technical_report.title | notApplicablePipe | async | highlight : this.searchTerms }}
                                                </p>
                                            </ng-template>
                                        </td>
                                        <td scope="row" innerHTML="{{ technical_report.file_size | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ technical_report.file_size | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ technical_report.pages  | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ technical_report.pages  | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ technical_report.comments | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ technical_report.comments | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
                
                <div *ngIf="otherDocuments">
                    <div>
                        <h3 class="mb-2">
                            {{ 'other.documents' | translate | async }}
                        </h3>
                    </div>
                    <div class="ontario-table-container">
                        <div class="ontario-table-div mb-0">
                            <table class="flex-child" tabindex="0">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'title' | translate | async }}</th>
                                        <th scope="col">{{ 'subject' | translate | async }}</th>
                                        <th scope="col">{{ 'type' | translate | async }}</th>
                                        <th scope="col">{{ 'number.of.items' | translate | async }}</th>
                                        <th scope="col">{{ 'scale' | translate | async }}</th>
                                        <th scope="col">{{ 'file.size.kb' | translate | async }}</th>
                                        <th scope="col">{{ 'comments' | translate | async }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let map of record.maps">
                                        <td scope="row">
                                            <ng-container *ngIf="map.file_name && map.file_name != ''; else titleOnly">
                                                <a target="_blank" 
                                                    innerHTML="{{ map.title | highlight : this.searchTerms }}"
                                                    href="{{this.downloadsAZStorage}}/{{map.file_name}}">
                                                    {{ map.title | highlight : this.searchTerms }}
                                                </a>                                            
                                            </ng-container>
                                            <ng-template #titleOnly>
                                                <p innerHTML="{{ map.title | highlight : this.searchTerms }}">
                                                    {{ map.title | highlight : this.searchTerms }}
                                                </p>
                                            </ng-template>
                                        </td>
                                        <td scope="row" innerHTML="{{ map.subject_id | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ map.subject_id | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ map.map_type | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ map.map_type | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ map.nr_items | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ map.nr_items | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ map.scale | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ map.scale | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ map.file_size | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ map.file_size | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                        <td scope="row" innerHTML="{{ map.comments | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ map.comments | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #fileIdentifiersTable>
            <div class="ontario-table-container">
                <div class="ontario-table-div mb-0">
                    <table class="flex-child" tabindex="0">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'identifier' | translate | async }}</th>
                                <th scope="col">{{ 'type' | translate | async }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let file_identifier of record.file_identifiers">
                                <td scope="row" innerHTML="{{ file_identifier.id | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ file_identifier.id | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ file_identifier.name | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ file_identifier.name | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>

        <ng-template #workTypesTable>
            <div class="ontario-table-container">
                <div class="ontario-table-div mb-0">
                    <table class="flex-child" tabindex="0">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'work.group' | translate | async }}</th>
                                <th scope="col">{{ 'work.type' | translate | async }}</th>
                                <th scope="col">{{ 'quantity' | translate | async }}</th>
                                <th scope="col">{{ 'comments' | translate | async }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let work_type of record.work_types">
                                <td scope="row" innerHTML="{{ work_type.group_name | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ work_type.group_name | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ work_type.description | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ work_type.description | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{work_type.quantity | notApplicablePipe | async  | highlight : this.searchTerms }}">
                                    {{ work_type.quantity | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ work_type.comments | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ work_type.comments | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>

        <ng-template #commoditiesTable>
            <div class="ontario-table-container">
                <div class="ontario-table-div mb-0">
                    <table class="flex-child" tabindex="0">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'commodity' | translate | async }}</th>
                                <th scope="col">{{ 'group' | translate | async }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let commodity of record.commodities">
                                <td scope="row" innerHTML="{{ commodity.description | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ commodity.description | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ commodity.category | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ commodity.category | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>

        <ng-template #authorsTable>
            <div class="ontario-table-container">
                <div class="ontario-table-div mb-0">
                    <table class="flex-child" tabindex="0">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'author.name' | translate | async }}</th>
                                <th scope="col">{{ 'company' | translate | async }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let author of record.authors">
                                <td scope="row" innerHTML="{{ author.name | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ author.name | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ author.company | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ author.company | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>

        <ng-template #locationTable>
            <div class="ontario-table-container">
                <div class="ontario-table-div mb-0">
                    <table class="flex-child" tabindex="0">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'easting' | translate | async }}</th>
                                <th scope="col">{{ 'northing' | translate | async }}</th>
                                <th scope="col">{{ 'utm.zone' | translate | async }}</th>
                                <th scope="col">{{ 'utm.datum' | translate | async }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let location of record.location">
                                <td scope="row" innerHTML="{{ location.utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ location.utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ location.utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ location.utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ location.utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ location.utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ location.utm_datum | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ location.utm_datum | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>

        <ng-template #claimHoldersTable>
            <div class="ontario-table-container">
                <div class="ontario-table-div mb-0">
                    <table class="flex-child" tabindex="0">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'claim.holder.name' | translate | async }}</th>
                                <th scope="col">{{ 'client.number' | translate | async }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let claim_holder of record.claim_holders">
                                <td scope="row" innerHTML="{{ claim_holder.claim_holder_name | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ claim_holder.claim_holder_name | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                                <td scope="row" innerHTML="{{ claim_holder.ministry_client_num | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ claim_holder.ministry_client_num | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>

        <ng-template #claimsTable>
            <div class="ontario-table-container">
                <div class="ontario-table-div mb-0">
                    <table class="flex-child" tabindex="0">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'claim.number' | translate | async }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let claim of record.claims">
                                <td scope="row" innerHTML="{{ claim.clm_cell_num | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ claim.clm_cell_num | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>

    </div>

    <!-- Scroll Button -->
    <button onClick="scrollToTop()" class="ontario-back-to-top--default">
        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-arrow-up"></use>
        </svg>
        {{ 'top' | translate | async }}
    </button>
    
</div>